import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI, muvekkilAPI, MUVEKKIL_TOKEN_KEY, MUVEKKIL_BILGI_KEY } from '../api/api';
import { widgetJetonuYaz } from '../utils/widgetKoprusu';
import {
  faceIdVarMi, faceIdAcikMi, faceIdAc, faceIdIleGir, faceIdAnahtariniTazele,
  faceIdKayitliMi, girisBilgisiniHatirla,
} from '../utils/faceId';
import './Login.css';

/* TESHIS: giris ekraninda Face ID'nin ne yaptigi sunucu kaydina yazilir
   (oturum yokken de calisan uc). Kullanici "her giriste sifre soruyor"
   dediginde tahmin etmek yerine telefonun ne yaptigini goruyoruz. */
const girisTani = (metin) => {
  try { if (!document.body.classList.contains('capacitor-native')) return; } catch (e) { return; }
  authAPI.girisTani(metin);
};

const EyeIcon = ({ off }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
    {off && <line x1="3" y1="3" x2="21" y2="21" />}
  </svg>
);

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login, jetonlaGir, error, loading } = useAuth();
  const navigate = useNavigate();

  // Giriş türü: personel (yönetici/avukat) veya müvekkil
  /* WhatsApp'tan gelen bağlantı "?giris=muvekkil" taşır ve doğrudan
     müvekkil formunu açar. Uygulamayı ilk kez açan müvekkilin giriş
     türü kartıyla uğraşmasına gerek kalmıyor. Parametre yoksa ya da
     tanınmıyorsa her zamanki kart ekranı gelir. */
  const baslangicTuru = (() => {
    try {
      const p = new URLSearchParams(window.location.search).get('giris');
      return p === 'muvekkil' || p === 'personel' ? p : null;
    } catch { return null; }
  })();

  const [girisTuru, setGirisTuru] = useState(baslangicTuru); // null | personel | muvekkil
  const [mTc, setMTc] = useState('');
  const [mSifre, setMSifre] = useState('');
  const [mHata, setMHata] = useState('');
  const [mYukleniyor, setMYukleniyor] = useState(false);

  /* İlk girişte şifre belirleme adımı.
     Sunucu eski şema ya da tek kullanımlık kodla girildiğini bildirdiğinde
     müvekkil dosyalarına geçmeden önce kendi şifresini belirler. */
  const [sifreAdimi, setSifreAdimi] = useState(false);
  const [yeniSifre, setYeniSifre] = useState('');
  const [yeniSifre2, setYeniSifre2] = useState('');

  const muvekkilGiris = async (e) => {
    e.preventDefault();
    return muvekkilGirisYap(mTc, mSifre);
  };

  /* Buro girisi durdurduysa sunucu bunu ayrica bildirir; Face ID akisi
     o zaman "sifreniz degismis olabilir" gibi yaniltici bir mesaj vermez. */
  const girisDurduruldu = useRef(false);

  /** Muvekkil girisi; formdan da Face ID ile doldurulan bilgilerden de cagrilir. */
  const muvekkilGirisYap = async (tc, sifre) => {
    setMHata('');
    setMYukleniyor(true);
    girisDurduruldu.current = false;
    try {
      const sonuc = await muvekkilAPI.login(tc, sifre);
      girisBilgisiniHatirla('muvekkil', tc, sifre);
      localStorage.setItem(MUVEKKIL_TOKEN_KEY, sonuc.token);
      // Ana ekran widget'i oturumu buradan okuyor.
      widgetJetonuYaz(sonuc.token, 'muvekkil');
      // Teklif girisi bekletmez (bkz. personel girisindeki aciklama).
      if (faceIdMumkun && !faceIdAcikMi()) {
        faceIdAc(sonuc.token, 'muvekkil').catch(() => {});
      } else {
        faceIdAnahtariniTazele('muvekkil');
      }
      localStorage.setItem(MUVEKKIL_BILGI_KEY, JSON.stringify({
        tc: sonuc.tc, adSoyad: sonuc.adSoyad, dosyaSayisi: sonuc.dosyaSayisi,
      }));

      // Oturum açıldı ama şifre hâlâ tahmin edilebilir eski şemada;
      // dosyalara geçmeden önce kendi şifresini belirlesin.
      if (sonuc.sifreBelirlemeGerekli ?? sonuc.SifreBelirlemeGerekli) {
        setSifreAdimi(true);
        return;
      }
      navigate('/muvekkil');
      return true;
    } catch (err) {
      girisDurduruldu.current = !!err?.response?.data?.girisDurduruldu;
      setMHata(err?.response?.data?.message || 'Giriş yapılamadı. Bilgilerinizi kontrol edin.');
      return false;
    } finally {
      setMYukleniyor(false);
    }
  };

  const sifreKaydet = async (e) => {
    e.preventDefault();
    setMHata('');
    if (yeniSifre.length < 6) { setMHata('Şifre en az 6 karakter olmalıdır.'); return; }
    if (yeniSifre !== yeniSifre2) { setMHata('Şifreler birbirini tutmuyor.'); return; }
    setMYukleniyor(true);
    try {
      await muvekkilAPI.sifreBelirle(yeniSifre);
      // Face ID ile giris icin saklanan sifre de yenisi olsun.
      girisBilgisiniHatirla('muvekkil', mTc, yeniSifre);
      navigate('/muvekkil');
    } catch (err) {
      setMHata(err?.response?.data?.message || 'Şifre kaydedilemedi.');
    } finally {
      setMYukleniyor(false);
    }
  };


  /* FACE ID
     Telefonda Face ID tanimliysa ve kullanici daha once bu girisi
     actiysa, giris ekrani acilir acilmaz yuz soruluyor. Basarisiz
     olursa ya da vazgecilirse her zamanki sifreli giris duruyor. */
  const [faceIdMumkun, setFaceIdMumkun] = useState(false);
  const [faceIdKayitli, setFaceIdKayitli] = useState(false);
  const [faceIdDeneniyor, setFaceIdDeneniyor] = useState(false);
  const faceIdDenendi = useRef(false);

  /* BEKLEMEDEN SOR. Eskiden once telefona "Face ID hazir mi?" soruluyor,
     cevap gelince Face ID deneniyordu. Uygulama yeni acildiginda bu soru
     8 saniyeye kadar cevapsiz kalabiliyor; kullanici o arada sifreyi
     yaziyordu ve Face ID hic denenmiyordu (2026-10-02 kaydi: sifre 9 sn
     sonra girildi, Face ID istegi yok). Artik bu telefonda Face ID kaydi
     varsa yuz hemen soruluyor; "hazir mi" sorusu yalnizca ilk kez acma
     teklifi icin, arka planda. */
  useEffect(() => {
    let iptal = false;
    // Oturum zaten aciksa giris ekraninda durmanin anlami yok; Face ID de
    // sorulmaz (her soruldugunda yeni bir oturum acilip baska cihazdaki
    // oturum dusuyordu).
    if (localStorage.getItem('token')) { navigate('/dashboard', { replace: true }); return undefined; }
    if (localStorage.getItem(MUVEKKIL_TOKEN_KEY)) { navigate('/muvekkil', { replace: true }); return undefined; }
    (async () => {
      const kayitli = await faceIdKayitliMi();
      if (iptal) return;
      setFaceIdKayitli(kayitli);
      girisTani(`acilis kayitli=${kayitli}`);
      if (kayitli && !faceIdDenendi.current) {
        faceIdDenendi.current = true;
        faceIdIleDene();
      }
    })();
    (async () => {
      const var_ = await faceIdVarMi();
      if (!iptal) setFaceIdMumkun(var_);
    })();
    return () => { iptal = true; };
  }, []); // eslint-disable-line

  /* Yuz BIR KEZ sorulur; saklanan anahtarla sunucudan yeni oturum alinir.
     Sayfa ancak oturum gercekten acildiktan sonra degisir. Eskiden jeton
     denetlenmeden ana sayfaya geciliyor, sunucu reddedince giris sayfasi
     yeniden yukleniyor ve Face ID tekrar soruluyordu (dongu). */
  const [faceIdHata, setFaceIdHata] = useState('');

  const faceIdIleDene = async () => {
    setFaceIdHata('');
    setFaceIdDeneniyor(true);
    try {
      const anahtarlar = await faceIdIleGir();
      if (!anahtarlar) { girisTani('yuz dogrulanmadi/vazgecildi'); return; } // sifreli giris duruyor
      girisTani(`yuz tamam pBilgi=${!!anahtarlar.personelBilgi} pAnahtar=${!!anahtarlar.personel}`
        + ` mBilgi=${!!anahtarlar.muvekkilBilgi} mAnahtar=${!!anahtarlar.muvekkil}`);

      // 1) Kayitli giris bilgileri: kutulara doldurulur ve normal giris yapilir.
      if (anahtarlar.personelBilgi) {
        const { kullanici, sifre } = anahtarlar.personelBilgi;
        setGirisTuru('personel');
        setUsername(kullanici);
        setPassword(sifre);
        if (await personelGirisYap(kullanici, sifre)) { girisTani('bilgiyle giris tamam (personel)'); return; }
        girisTani('bilgiyle giris basarisiz (personel)');
      }
      if (anahtarlar.muvekkilBilgi) {
        const { kullanici, sifre } = anahtarlar.muvekkilBilgi;
        setGirisTuru('muvekkil');
        setMTc(kullanici);
        setMSifre(sifre);
        if (await muvekkilGirisYap(kullanici, sifre)) { girisTani('bilgiyle giris tamam (muvekkil)'); return; }
        girisTani('bilgiyle giris basarisiz (muvekkil)');
        // Giris buro tarafindan durdurulmus: sunucunun mesaji ekranda; baska yol denenmez.
        if (girisDurduruldu.current) return;
      }

      // 2) Bilgi kaydi yoksa (bu surumden once acilmis Face ID) cihaz anahtari.
      if (anahtarlar.personel) {
        try {
          const { token } = await authAPI.faceIdGiris(anahtarlar.personel);
          const sonuc = await jetonlaGir(token);
          if (sonuc.success) { navigate('/dashboard'); return; }
        } catch (e) { /* asagida muvekkil denenir */ }
      }

      if (anahtarlar.muvekkil) {
        try {
          const sonuc = await muvekkilAPI.faceIdGiris(anahtarlar.muvekkil);
          localStorage.setItem(MUVEKKIL_TOKEN_KEY, sonuc.token);
          widgetJetonuYaz(sonuc.token, 'muvekkil');
          localStorage.setItem(MUVEKKIL_BILGI_KEY, JSON.stringify({
            tc: sonuc.tc, adSoyad: sonuc.adSoyad, dosyaSayisi: sonuc.dosyaSayisi,
          }));
          navigate('/muvekkil');
          return;
        } catch (e) {
          if (e?.response?.data?.girisDurduruldu) {
            setGirisTuru('muvekkil');
            setMHata(e.response.data.message);
            return;
          }
          /* asagida mesaj */
        }
      }

      girisTani('giris acilamadi');
      // Tur secim ekranindaysa ilgili formu ac ki mesaj ve sifre alani gorunsun.
      setGirisTuru((t) => t || (anahtarlar.personel || anahtarlar.personelBilgi ? 'personel' : 'muvekkil'));
      setFaceIdHata('Face ID ile giriş yapılamadı (şifreniz değişmiş olabilir). Lütfen bir kez '
        + 'şifrenizle girin; bilgileriniz kaydedilir ve sonraki girişlerde Face ID çalışır.');
    } finally {
      setFaceIdDeneniyor(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await personelGirisYap(username, password);
  };

  /** Personel girisi; formdan da Face ID ile doldurulan bilgilerden de cagrilir. */
  const personelGirisYap = async (kullanici, sifre) => {
    const result = await login('', sifre, kullanici);

    if (result.success) {
      girisBilgisiniHatirla('personel', kullanici, sifre);
      /* FACE ID TEKLIFI GIRISI ASLA BEKLETMEZ.
         Onceden burada "await faceIdAc(...)" vardi. Face ID penceresi
         acilip cevap alamadiginda (ornegin simulatorde, ya da kullanici
         pencereyi gormeden telefonu birakinca) giris o satirda asili
         kaliyor, ana sayfaya hic gecilmiyordu: sifre dogru olmasina
         ragmen "giris yapmiyor" gorunuyordu.
         Artik teklif arka planda calisiyor, yonlendirme hemen yapiliyor. */
      if (faceIdMumkun && !faceIdAcikMi()) {
        const jeton = localStorage.getItem('token');
        if (jeton) faceIdAc(jeton, 'personel').catch(() => {});
      } else {
        faceIdAnahtariniTazele('personel');
      }
      navigate('/dashboard');
      return true;
    }
    return false;
  };

  // Klavye acilinca odaklanan alan gorunur kalsin.
  //
  // iOS'ta klavye WebView'i kucultuyor ama odaklanan alani her zaman
  // gorunur alana tasimiyor; kart klavyenin altinda kaliyordu.
  // Odak olayindan sonra kisa bir gecikmeyle (klavye animasyonu bitsin)
  // alani ekranin ortasina kaydiriyoruz.
  useEffect(() => {
    const odaklandi = (e) => {
      const el = e.target;
      if (!el || !el.matches || !el.matches('input, select, textarea')) return;
      window.setTimeout(() => {
        try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) { /* yoksay */ }
      }, 350);
    };
    document.addEventListener('focusin', odaklandi);
    return () => document.removeEventListener('focusin', odaklandi);
  }, []);

  return (
    <div className="login-page">
      <div className="login-page-bg" aria-hidden="true" />
      <div className="login-yildizlar" aria-hidden="true" />
      <div className="login-shell">
        <div className="login-brand-head">
          <div className="login-brand-mark">
            <img src="/assets/logo.png" alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          </div>
          <div className="login-brand-heading">
            <h1 className="login-brand-title">Öztürk Hukuk ve Danışmanlık</h1>
            <p className="login-brand-eyebrow">Hukuk Bürosu Yönetim Sistemi</p>
          </div>
        </div>

        <div className="login-brand">
          <p className="login-brand-text">Ofis çalışanlarının dosya, duruşma ve görev takibi ile müvekkillerin dosyalarını takibi içindir.</p>
          <p className="login-brand-avukat">Av. İzzet Baran ÖZTÜRK</p>

          <div className="login-links">
          <a
            className="login-app-link"
            href="https://www.ozturkhukukburosu.net"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M3 12h18" />
              <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18Z" />
            </svg>
            <span>
              <strong>Web sitemiz</strong>
              <em>ozturkhukukburosu.net</em>
            </span>
          </a>

          <a
            className="login-app-link"
            href="https://apps.apple.com/app/id6797491601"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M16.4 12.8c0-2.1 1.7-3.1 1.8-3.2-1-1.4-2.5-1.6-3-1.6-1.3-.1-2.5.8-3.1.8-.6 0-1.6-.8-2.7-.755-1.4.02-2.7.8-3.4 2.05-1.45 2.5-.37 6.2 1.04 8.2.69.99 1.5 2.1 2.57 2.06 1.03-.04 1.42-.67 2.67-.67 1.24 0 1.6.67 2.69.65 1.11-.02 1.81-1 2.49-2 .78-1.14 1.1-2.25 1.12-2.3-.02-.01-2.15-.83-2.17-3.28ZM14.5 6.6c.56-.68.94-1.63.84-2.6-.81.03-1.79.54-2.37 1.22-.52.6-.98 1.56-.86 2.48.9.07 1.83-.46 2.39-1.1Z" />
            </svg>
            <span>
              <strong>Mobil uygulama</strong>
              <em>App Store</em>
            </span>
          </a>
          </div>
        </div>

        {!girisTuru && (
          <div className="login-secim login-sahne">
                <button
                  type="button"
                  className="login-secim-kart"
                  onClick={() => setGirisTuru('personel')}
                >
                  <span className="login-secim-mark" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 2.6l7.5 3.2v5.7c0 4.6-3.1 8.3-7.5 9.9-4.4-1.6-7.5-5.3-7.5-9.9V5.8L12 2.6Z" />
                      <path d="m9 12.2 2 2 4.2-4.4" />
                    </svg>
                  </span>
                  <span className="login-secim-yazi">
                    <span className="login-secim-baslik">Yönetici / Avukat Girişi</span>
                    <span className="login-secim-aciklama">Kullanıcı adınız ve şifrenizle</span>
                  </span>
                  <span className="login-secim-ok" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12h13" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </span>
                </button>

                <button
                  type="button"
                  className="login-secim-kart"
                  onClick={() => setGirisTuru('muvekkil')}
                >
                  <span className="login-secim-mark" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="8.2" r="3.5" />
                      <path d="M4.9 20c.7-3.7 3.6-5.8 7.1-5.8s6.4 2.1 7.1 5.8" />
                    </svg>
                  </span>
                  <span className="login-secim-yazi">
                    <span className="login-secim-baslik">Müvekkil Girişi</span>
                    <span className="login-secim-aciklama">TC kimlik numaranız ve şifrenizle</span>
                  </span>
                  <span className="login-secim-ok" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12h13" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </span>
                </button>
          </div>
        )}

        {girisTuru && (
        <div className="login-card">
          <div className="login-sahne">
          <button type="button" className="login-geri" onClick={() => setGirisTuru(null)}>
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M19 12H6" />
              <path d="m12 19-7-7 7-7" />
            </svg>
            Giriş türünü değiştir
          </button>

          <div className="login-card-header">
            <h2>
              {sifreAdimi
                ? 'Şifrenizi Belirleyin'
                : girisTuru === 'muvekkil' ? 'Müvekkil Girişi' : 'Giriş Yap'}
            </h2>
            <p>
              {sifreAdimi
                ? 'Güvenliğiniz için kendi şifrenizi belirleyin. Bundan sonra yalnızca bu şifre geçerli olacak.'
                : girisTuru === 'muvekkil'
                  ? 'TC kimlik numaranız ve size verilen şifre ile'
                  : 'Hesabınızla sisteme devam edin'}
            </p>
          </div>

          {sifreAdimi ? (
            <form onSubmit={sifreKaydet}>
              <div className="form-group">
                <label htmlFor="y-sifre">Yeni şifreniz</label>
                <div className="login-password-wrap">
                  <input
                    id="y-sifre"
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    value={yeniSifre}
                    onChange={(e) => setYeniSifre(e.target.value)}
                    placeholder="En az 6 karakter"
                    autoComplete="new-password"
                    autoFocus
                    required
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                  >
                    <EyeIcon off={showPassword} />
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="y-sifre2">Yeni şifreniz (tekrar)</label>
                <input
                  id="y-sifre2"
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  value={yeniSifre2}
                  onChange={(e) => setYeniSifre2(e.target.value)}
                  placeholder="Aynı şifreyi tekrar yazın"
                  autoComplete="new-password"
                  required
                />
              </div>

              {mHata && <div className="error-message">{mHata}</div>}

              <button type="submit" className="btn btn-primary login-submit" disabled={mYukleniyor}>
                {mYukleniyor ? 'Kaydediliyor...' : 'Şifremi Belirle ve Devam Et'}
              </button>

              <p className="login-sifre-not">
                Şifreniz şifrelenerek saklanır; büro dahil kimse göremez.
                Unutursanız büromuzdan yeni giriş kodu isteyebilirsiniz.
              </p>
            </form>
          ) : girisTuru === 'muvekkil' ? (
            <form onSubmit={muvekkilGiris}>
              <div className="form-group">
                {/* Şirket müvekkillerin TC'si yoktur; alan 10 haneli vergi
                    numarasını da kabul eder. */}
                <label htmlFor="m-tc">TC Kimlik No / Vergi No</label>
                <input
                  id="m-tc"
                  type="text"
                  inputMode="numeric"
                  maxLength={11}
                  className="form-control"
                  value={mTc}
                  onChange={(e) => setMTc(e.target.value.replace(/[^0-9]/g, ''))}
                  placeholder="TC kimlik no veya vergi no"
                  autoFocus
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="m-sifre">Şifre</label>
                <div className="login-password-wrap">
                  <input
                    id="m-sifre"
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    value={mSifre}
                    onChange={(e) => setMSifre(e.target.value)}
                    placeholder="Örn. 123.294"
                    required
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                  >
                    <EyeIcon off={showPassword} />
                  </button>
                </div>
              </div>

              {mHata && <div className="error-message">{mHata}</div>}

              <button type="submit" className="btn btn-primary login-submit" disabled={mYukleniyor}>
                {mYukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
              </button>

            {/* Face ID: yalnizca telefonda tanimliysa ve kullanici
                daha once actiysa gorunur. Tarayicida hic cikmaz. */}
            {faceIdHata && <div className="error-message">{faceIdHata}</div>}
            {(faceIdKayitli || (faceIdMumkun && faceIdAcikMi())) && (
              <button
                type="button"
                className="login-faceid"
                onClick={faceIdIleDene}
                disabled={faceIdDeneniyor}
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2" />
                  <path d="M9 10v1M15 10v1M12 10v3l-1 1M9 15.5s1.2 1 3 1 3-1 3-1" />
                </svg>
                <span>{faceIdDeneniyor ? 'Doğrulanıyor…' : 'Face ID ile gir'}</span>
              </button>
            )}
            </form>
          ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="login-username">Kullanıcı Adı</label>
              <input
                id="login-username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-control"
                required
                autoFocus
                autoComplete="username"
                placeholder="kullaniciadi"
              />
            </div>

            <div className="form-group">
              <label htmlFor="login-password">Şifre</label>
              <div className="login-password-wrap">
                <input
                  id="login-password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control"
                  required
                  autoComplete="current-password"
                  placeholder="Şifreniz"
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                  title={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                >
                  <EyeIcon off={showPassword} />
                </button>
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="btn btn-primary login-submit" disabled={loading}>
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>

            {/* Face ID: yalnizca telefonda tanimliysa ve kullanici
                daha once actiysa gorunur. Tarayicida hic cikmaz. */}
            {faceIdHata && <div className="error-message">{faceIdHata}</div>}
            {(faceIdKayitli || (faceIdMumkun && faceIdAcikMi())) && (
              <button
                type="button"
                className="login-faceid"
                onClick={faceIdIleDene}
                disabled={faceIdDeneniyor}
              >
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2" />
                  <path d="M9 10v1M15 10v1M12 10v3l-1 1M9 15.5s1.2 1 3 1 3-1 3-1" />
                </svg>
                <span>{faceIdDeneniyor ? 'Doğrulanıyor…' : 'Face ID ile gir'}</span>
              </button>
            )}
          </form>
          )}
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Login;
